import { INSURANCE_TYPE } from '@orcar/common-d2c';
import { getInsuranceName } from '@/utils/insurance';

export const INSURANCE_BUTTONS = [
  {
    id: INSURANCE_TYPE.NORMAL,
    label: getInsuranceName(INSURANCE_TYPE.NORMAL),
  },
  {
    id: INSURANCE_TYPE.PERFECT,
    label: getInsuranceName(INSURANCE_TYPE.PERFECT),
  },
  {
    id: INSURANCE_TYPE.SUPER,
    label: '완전면책',
  },
];
export const INSURANCE_RANGE = [
  {
    insurance: '일반면책',
    info: '최소한의 보장만 필요하다면',
    range: [
      ': 50만원',
      ': 50% 고객 부담',
      ': 500만원',
      ': 보상 제외',
      ': 불가',
    ],
    xPosition: '35px',
  },
  {
    insurance: '고급면책',
    info: '운전이 익숙해도 왠지 불안하다면',
    range: [
      ': 100만원',
      ': 없음',
      ': 1,500만원',
      ': 보상 포함(자기부담금 100만원)',
      ': 불가',
    ],
    xPosition: '23px',
  },
  {
    insurance: '완전면책',
    info: '안심하고 여행하고 싶다면',
    range: [': 없음', ': 없음', ': 무제한', ': 보상 가능', ': 보상'],
    xPosition: '38px',
  },
];

export const INSURANCE_INFO = [
  {
    title: '자기부담금',
    subs: [
      `사고 시 운전자가 부담하는 금액
      (종합보험 접수 시 대인/대물/자손 각각 50만원 발생)`,
    ],
    items: ['50만원', '100만원', '없음'],
  },
  {
    title: '휴차 보상료',
    subs: ['사고 발생 후 차량 수리 기간 동안 영업 손실 비용'],
    items: ['50% 고객 부담', '없음', '없음'],
  },
  {
    title: '보상 한도',
    subs: ['보험으로 처리 가능한 사고 비용의 최대 한도'],
    items: ['500만원', '1,500만원', '무제한'],
  },
  {
    title: '단독 사고',
    subs: [
      '과실 유무와 상관없이 주.정차된 차량 및',
      '시설물을 접촉하거나 본인과실 100% 사고인 경우',
    ],
    items: ['보상 제외', '보상 포함\n(자기부담금 100만원)', '보상 가능'],
  },
  {
    title: '휠/타이어 보장',
    subs: ['배터리, 사고 후 견인 10km까지 보장'],
    items: ['보장 불가', '보장 불가', '보상 가능'],
  },
];
